@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.formRoot {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 16px;
}

.formRootStandalone {
  flex: none;
}

.formFields {
  @include custom-scroll-minimal;
  flex: 1;
  overflow-y: auto;
}

.formFieldsStandalone {
  flex: none;
  overflow: visible;
}

.inputWrapper {
  @include typography-v2-body-base;
}

.labels {
  @include typography-v2-body-base;
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
}

.editorWrapper {
  display: flex;
  flex-direction: column;
}

.proTip {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.saveError {
  @include typography-v2-body-sm;
  color: var(--status-negative-default);
  margin: 0;
}

.footer {
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  padding: 8px 12px 12px;
}

.footerStandalone {
  padding: 0;
}

.cancelButton {
  padding: 8px 12px;
  flex: 1 0 0;
}

.saveButton {
  padding: 8px 12px;
  flex: 1 0 0;
}

.saveButtonStandalone {
  flex: none;
  width: 160px;
  @include border-radius-r2;
}
